import DataTable from 'app/components/table/DataTable'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  container: {
    color: theme.palette.text.primary,
    '& .ReactTable': {
      border: 'none',
    },
    '& .ReactTable .rt-thead.-header': {
      'box-shadow': 'none !important',
    },
    '& .rt-resizable-header-content': {
      color: `${theme.palette.text.primary} !important`,
    },
    '& .rt-resizable-header:last-child ': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '$ .status-success': {
      color: theme.palette.billing.positive,
    },
    '$ .status-failure': {
      color: theme.palette.negative.main,
    },
  },
}))

const NoDataComponent = (label) => (props) => (
  <Typography className="text-center" {...props}>
    {label}
  </Typography>
)

export function PlanBillingTable(props) {
  const classes = useStyles()

  return (
    <div className={clsx(classes.container)}>
      <DataTable
        NoDataComponent={NoDataComponent(props.noDataLabel)}
        {...props}
      />
    </div>
  )
}

PlanBillingTable.propTypes = {
  noDataLabel: PropTypes.string,
}
